import React, { Fragment } from 'react';
import styled from 'styled-components'
import { withFormik } from 'formik';
import Yup from 'yup';
import TextInput from "../../components/Form/TextInputUX";
import ButtonWrapper from "../../components/Form/ButtonWrapper";
import Button from "../../collections/Button/Button";
import FormikForm from "../../components/Form/FormikForm";
import PasswordRequirements from "../../components/PasswordRequirements/PasswordRequirements";
import Paragraph from "../../collections/Paragraph/Paragraph";
import {media} from "../../utilities/style-utilities";
import {withRouter} from "react-router-dom";
import Status from "../../components/Status/Status";
import {emy, fontUbuntuLight} from "../../utilities/utilities";
import SessionStorage from "../../storage/SessionStorage/SessionStorage";
const queryString = require('query-string');

const center = {
  textAlign:'center',
  alignSelf:'center',
  maxWidth:'80%',
  margin:'15px auto 15px auto'
};

const centerBold = {
    textAlign:'center',
    alignSelf:'center',
    maxWidth:'80%',
    fontWeight:'bold',
    margin:'0 auto'
}



const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1rem;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  ${ media.desktop`
    flex-direction: row;
  `}
`;

const FlexRowItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  ${ media.desktop`
    flex: 1 1 auto;
  `}
`;
const buttonStyle = {
    width:'auto' ,
    padding:'.6rem 3rem;',
    fontSize: emy(15)
};

let requirements = {
    long :false,
    number : false,
    uppercase : false,
    specialchar : false
}
const NewPassword = (props) => {
    return (
        <Fragment>
                    <Paragraph style={centerBold}>{props.appState.ui.newPassword.meta.descriptionTitle}</Paragraph>
                    <Paragraph style={center}>{props.appState.ui.newPassword.meta.description} <a  href={props.appState.ui.newPassword.meta.link} target="_blank">here</a></Paragraph>
                    <Status isVisible={props.appState.cardActivation.error.isVisible} message={props.appState.cardActivation.error.message} type={props.appState.cardActivation.error.type}/>

                    <FormikForm>
                        <FlexRow>
                            <FlexRowItem>
                                <PasswordRequirements requirements={requirements}/>
                                <TextInput
                                    name="newPassword"
                                    type={props.appState.ui.newPassword.formValidation.newPassword.inputType}
                                    label={props.appState.ui.newPassword.formValidation.newPassword.label}
                                    placeholder={props.appState.ui.newPassword.formValidation.newPassword.placeholder}
                                />

                                <TextInput
                                    name="confirmPassword"
                                    type={props.appState.ui.newPassword.formValidation.confirmPassword.inputType}
                                    label={props.appState.ui.newPassword.formValidation.confirmPassword.label}
                                    placeholder={props.appState.ui.newPassword.formValidation.confirmPassword.placeholder}
                                />

                                <ButtonWrapper>
                                    <Button
                                        style={buttonStyle}
                                        color={props.appState.ui.newPassword.buttons.submit.textColor}
                                        background={props.appState.ui.newPassword.buttons.submit.backgroundColor}
                                        border={props.appState.ui.newPassword.buttons.submit.borderColor}
                                        type="submit"
                                        role="button">
                                        {props.appState.ui.newPassword.buttons.submit.text}
                                    </Button>
                                </ButtonWrapper>
                            </FlexRowItem>
                        </FlexRow>
                    </FormikForm>
        </Fragment>
    );
};

const EnhancedForm = withFormik({
    mapPropsToValues: (props) => ({
        verificationCode:'',
        newPassword:'',
        confirmPassword:'',

    }),
    validationSchema: (props) => {
        return Yup.object().shape({
        newPassword: Yup.string()
            .matches(new RegExp(`(?=.*[a-z])`), `The password must contain at least 1 lowercase alphabetical character`)
            .matches(new RegExp(`(?=.*[A-Z])`), `The password must contain at least 1 uppercase alphabetical character`)
            .matches(new RegExp(`(?=.*[0-9])`), `The password must contain at least 1 numeric character`)
            .matches(new RegExp(`(?=.[!@#\\$%\\^&])`), `The password must contain at least one special character (@,!,#, etc)`)
            .min(8, "The password must have at least 8 characters.")
            .required(props.appState.ui.newPassword.formValidation.newPassword.requiredMessage)
            .test( (password) =>{
                requirements.long = password.length < 8 ? false : true;
                requirements.number = !/(?=.*[0-9])/.test(password) ? false : true;
                requirements.uppercase = !/(?=.*[A-Z])/.test(password) ? false : true;
                requirements.specialchar = !/(?=.[!@#\\$%\\^&])/.test(password) ? false : true;
                return true;
            }),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], props.appState.ui.newPassword.formValidation.confirmPassword.invalid)
            .required(props.appState.ui.newPassword.formValidation.confirmPassword.requiredMessage),
    })},
    handleSubmit: (values, { props, setSubmitting }) => {
        SessionStorage.setSessionStorageItem('bal', '4061ddbfe486cce727972d8abc85171005b2911c3fb21aabd2481bab12fdba1b');
        props.update({
            loading: true,
            accessBalance: '4061ddbfe486cce727972d8abc85171005b2911c3fb21aabd2481bab12fdba1b'
        });
        props.handleErrorMessage(false, '');
        props.handleFormPrompt(false);

        props.api.getSessionData(props.appState.session.SessionDataId)
            .then(response => {
                let sessionData = response;
                let password = values.newPassword;
                sessionData.CardActivationStatusId = 3;
                props.update({
                    session: {...sessionData, password}
                }, (state) => {
                    let username = ''
                    if (state.cardDetails.FirstName !== null && state.cardDetails.FirstName !== undefined && state.cardDetails.FirstName.length > 0) {
                        username = state.cardDetails.FirstName;
                    } else if (state.cardDetails.Title !== null && state.cardDetails.Title !== undefined && state.cardDetails.Title.length > 0) {
                        username = `${state.cardDetails.Title} ${state.cardDetails.LastName}`;
                    } else {
                        username = state.cardDetails.LastName;
                    }

                    let data = {};
                    data.CardSerialNumber = state.session.CardSerialNumber;
                    data.TemplateCode = state.settings.emailTemplate;
                    data.Payload = JSON.parse(state.settings.emailPayload);
                    data.Payload.toAddress = [state.session.UserEmail];
                    data.Payload.name = username;
                    data.Payload.firstName = state.cardDetails.FirstName;
                    data.Payload.lastName = state.cardDetails.LastName;
                    data.Payload.communicationCode = state.cardDetails.CardTypeCode;
                    data.Payload.MobileNumber = state.session.MobileNumber;
                    data.Payload.balance = state.session.CardBalance;
                    data.Payload.subscribed = state.session.CommunicationSubscriptions === null ? false : true;
                    // data.Payload.termsLink = state.settings.terms;
                    data.Payload.termsLink =  `${props.url === '/' ? window.location.origin + props.url +'terms' : window.location.origin + props.url + '/terms'}`;
                    data.Payload.password = state.session.password;


                    // console.log('payload data', data);

                    props.api.postSessionData(state.session)
                        .then(response => {

                            props.api.postCardActivationConfirmationEmail(data)
                                .then(response => {
                                    props.update({loading: false});
                                    props.history.push(props.generateURIFromCode(props.appState.code, 'balance'))
                                })
                                .catch(error => {
                                    // props.handleErrorMessage(true, 'Error: postCardActivationConfirmationEmail failed');
                                    props.update({loading: false});
                                    props.history.push(props.generateURIFromCode(props.appState.code, 'balance'))
                                })

                        })
                        .catch(error => {
                            props.handleErrorMessage(true, 'Error: postSessionData failed');
                            props.update({loading: false});
                        });
                });
            })
            .catch(error => {
                props.handleErrorMessage(true, 'Error: getSessionData failed');
                props.update({loading: false});
            })
    }
})(NewPassword);


export default  withRouter(EnhancedForm);


// WEBPACK FOOTER //
// ./src/containers/CardActivationPage/Step4.js